<template>
  <div id="firebaseui-auth-container"></div>
</template>

<script>
  import firebase from 'firebase'
  import * as firebaseui from 'firebaseui'
  import 'firebaseui/dist/firebaseui.css'

  export default {
    name: 'FirebaseUI',
    mounted() {
      // console.log(firebase)
      // console.log(firebaseui)
      const uiConfig = {
        signInFlow: 'popup',
        signInOptions: [
          // firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            fullLabel: this.$t('loginScreen.signInWithGoogle'),
          },
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            fullLabel: this.$t('loginScreen.signInWithEmail'),
          },
          // Add other providers as needed
        ],
        callbacks: {
          signInSuccessWithAuthResult: (authResult) => {
            if (authResult.user.email) {
              firebase
                .firestore()
                .collection('users')
                .where('email', '==', authResult.user.email)
                .get()
                .then((snapshot) => {
                  if (!snapshot.empty) {
                    const userDoc = snapshot.docs[0]
                    const userData = userDoc.data()

                    this.$store.commit('UserData/setUser', {
                      uid: userData.uid, // ✅ Use Firestore UID (not authResult.user.uid)
                      id: userDoc.id,
                      email: userData.email,
                      emailVerified: authResult.user.emailVerified,
                      phoneNumber: userData.phoneNumber,
                      fullPath: userData.fullPath,
                      user_name: userData.user_name,
                      url: userData.url,
                      cid: userData.cid,
                      roles: userData.roles,
                      active: userData.active,
                      activated: userData.activated,
                    })

                    this.$store.commit('UserData/setIsAuthenticated', true)

                    this.$store.dispatch('UserData/userLogin', {
                      uid: userData.uid,
                      email: userData.email,
                      emailVerified: authResult.user.emailVerified,
                      phoneNumber: userData.phoneNumber,
                    })
                  } else {
                    // fallback: use Firebase Auth UID if no Firestore user exists
                    this.$store.commit('UserData/setUser', {
                      uid: authResult.user.uid,
                      email: authResult.user.email,
                      emailVerified: authResult.user.emailVerified,
                      phoneNumber: authResult.user.phoneNumber,
                    })
                    this.$store.commit('UserData/setIsAuthenticated', true)

                    this.$store.dispatch('UserData/userLogin', {
                      uid: authResult.user.uid,
                      email: authResult.user.email,
                      emailVerified: authResult.user.emailVerified,
                      phoneNumber: authResult.user.phoneNumber,
                    })
                  }
                })
                .catch((error) => {
                  console.error('Error checking user in Firestore:', error)
                })

              return false // Prevent redirect
            }
          },
        },
      }
      // console.log(uiConfig)

      //Initialize the FirebaseUI Widget using Firebase
      const ui =
        firebaseui.auth.AuthUI.getInstance() ||
        new firebaseui.auth.AuthUI(firebase.auth())
      ui.start('#firebaseui-auth-container', uiConfig)
    },
  }
</script>
